import { componentsThemeMap } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import { Text } from '../../ui/Text.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
function HighlightAvatarCards({
  headline,
  subhead,
  children,
  gridColumns,
  style = 'default',
  anchor,
  hasSpacingTop
}) {
  const _componentsThemeMap$s = componentsThemeMap[style],
    background = _componentsThemeMap$s.background,
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HighlightAvatarCards",
      children: /*#__PURE__*/jsx(SectionComponentLayout, {
        anchor: anchor,
        hasSpacingHorizontal: true,
        background: background,
        hasSpacingTop: hasSpacingTop,
        hasNonDefaultBackgroundSpacingVertical: true,
        children: /*#__PURE__*/jsxs(Div, {
          width: "100%",
          flexDirection: "column",
          children: [/*#__PURE__*/jsxs(Div, {
            alignItems: "flex-start",
            flex: 1,
            flexDirection: "column",
            children: [headline && /*#__PURE__*/jsx(Text, {
              as: "h3",
              variant: "display2",
              color: foreground,
              spacingEnd: {
                md: 10
              },
              children: headline
            }), subhead && /*#__PURE__*/jsx(Text, {
              as: "p",
              variant: "body",
              spacingTop: 2,
              color: foregroundSecondary,
              children: subhead
            })]
          }), /*#__PURE__*/jsx(Div, {
            spacingTop: 7,
            flexDirection: "column",
            alignItems: "center",
            children: /*#__PURE__*/jsx(Div, {
              display: "grid",
              width: {
                xl: '100%'
              },
              rowGap: {
                sm: 12,
                md: 8,
                lg: 12
              },
              columnGap: {
                md: 9,
                lg: 2,
                xl: 7
              },
              gridTemplateColumns: {
                sm: 'repeat(1, 1fr)',
                md: 'repeat(2, 1fr)',
                lg: `repeat(${gridColumns}, 1fr)`
              },
              children: children
            })
          })]
        })
      })
    })
  });
}
export { HighlightAvatarCards };
//# sourceMappingURL=HighlightAvatarCards.js.map
